module.exports = __webpack_public_path__ + "img/0-36.c51beffd.jpg";